import { render, staticRenderFns } from "./ItemDetailsDialog.vue?vue&type=template&id=7a6ddc4e&"
import script from "./ItemDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./ItemDetailsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports